export const COMPRA = {
  base: "compra", qk: "compra", cap: "compra_cap", fields: ["pct", "precio"], save: ["pct", "precio", "precio_sd", "descuento", "iva"],
  headers: ["Precio sin descuento", "Descuento", "Precio con descuento", "IVA", "Precio KG", "Porcentaje (%)"], sum100: true, propaga: true,
  cols: [["sd", "w-36", "text-left"], ["desc", "w-36", "text-left"], ["cd", "w-36", "text-right"], ["iva", "w-36", "text-left"], ["kg", "w-32", "text-right"], ["pct", "w-[19rem]", "text-left pl-6"]],
  title: "Precios de compra", countLabel: "Conceptos con proveedor", countKey: "con_proveedor",
  desc: "Configuración semanal por planta de proveedor, porcentaje y precio de cada concepto del catálogo. Precio KG = (precio sin descuento − descuento) × IVA. P.C. = Σ(Precio KG × porcentaje).",
  initText: "proveedores del catálogo, porcentajes en 0% y precios en $0.00",
};

const FLETES = ["flete1", "flete2", "flete3", "flete4", "flete5"];

export const FLETE = {
  base: "fletes", qk: "fletes", cap: "flete_cap", fields: FLETES,
  headers: ["Porcentaje (%)", "Flete 1", "Flete 2", "Flete 3", "Flete 4", "Flete 5", "Flete"],
  title: "Precios de flete", countLabel: "Conceptos configurados", countKey: "configurados",
  desc: "Configuración semanal por planta de los fletes de cada concepto del catálogo. El porcentaje se toma de Precios de compra.",
  initText: "proveedores del catálogo e importes en $0.00",
};
